import { withGameContext } from "../../../hocs/with-game-context";
import { withLocalizationContext } from "../../../hocs/with-localization-context";
import { withSelectedLocale } from "../../../hocs/with-selected-locale";

import { withFilteredProps } from "./with-filtered-props";

import { TabController } from "./controller";
import { withData } from "./with-data";

export const TabContainer = withLocalizationContext(
    withGameContext(
        withSelectedLocale(withData(withFilteredProps(TabController))),
    ),
);
